import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import moment from 'moment';
import planer from 'planer';
import injectSheet from 'react-jss';
import pluralize from 'pluralize';
import { push as routerPush } from 'react-router-redux';
import { Paper, Avatar, LinearProgress, FlatButton } from 'material-ui';
import FlagIcon from 'material-ui/svg-icons/content/flag';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import MessageIcon from 'material-ui/svg-icons/editor/insert-comment';
import NotesIcon from 'material-ui/svg-icons/communication/chat-bubble';

import Attachments from '../../messaging/singleConv/regularAttachments';
import CommentContract from './comment-contract';
import MsgAvatar from '../../messaging/messaging-avatar';
import EmailTracking from './email-tracking';
import {
  addFileToContractFromMessage as addFileToContractFromMessageAction,
} from '../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import {
  removeSingleFeedByTCAdmin as removeSingleFeedByTCAdminAction,
} from '../__storeFiles__/actions';

const propTypes = {
  addFileToContractFromMessageAction: PropTypes.func,
  amendedFrom: PropTypes.string,
  amendmentCreated: PropTypes.string,
  classes: PropTypes.object,
  companyType: PropTypes.string,
  contractIdOfThread: PropTypes.string,
  downloadFromUrl: PropTypes.func,
  filesInContract: PropTypes.array,
  isInMessaging: PropTypes.bool,
  msgObject: PropTypes.object,
  routerPush: PropTypes.func,
  showContactLink: PropTypes.bool.isRequired,
  type: PropTypes.string,
  viewerCompanyId: PropTypes.string,
  isAnAdmin: PropTypes.bool,
  removeSingleFeedByTCAdmin: PropTypes.func,
  historyFeedId: PropTypes.string,
  isContractRequest: PropTypes.bool,
};

const styles = {
  paperBox: {
    backgroundColor: '#fafafa',
    display: 'inline-block',
    borderRadius: '10px',
    marginBottom: '24px',
    padding: '16px',
    width: '89%',
  },
  paperBoxNotes: {
    backgroundColor: '#fff5ea',
  },
  paperBoxMsgToDL: {
    backgroundColor: '#e3f2fd',
  },
  messageAvatarContainer: {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '0 5px',
    width: '11%',
  },
  messageAvatar: {
    marginTop: '10px',
    marginLeft: '15px',
    backgroundColor: '#90a4ae',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
    position: 'relative',
  },
  messageAvatarIcon: {
    color: 'white',
    fill: 'white',
  },
  messageSubject: {
    fontSize: '14px',
  },
  actualSubject: {
    fontWeight: 'bold',
  },
  messageBody: ({ msgObject: { bodyText } }) => ({
    display: bodyText ? 'block' : 'none',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '1em',
    overflowX: 'hidden',
    whiteSpace: 'pre-wrap',
    width: '100%',
  }),
  rateSheetsBox: {
    border: '2px solid #e0e0e0',
    borderRadius: '4px',
  },
  rateSheetsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
    padding: '8px',
  },
};

class Comment extends React.Component {
  constructor() {
    super();
    this.state = {
      showRecipients: false,
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  removeSingleFeedByTCAdmin = () => {
    const {
      removeSingleFeedByTCAdmin,
      historyFeedId,
      msgObject: {
        messageId,
      },
    } = this.props;
    removeSingleFeedByTCAdmin({ messageId, historyFeedId });
  };
  
  clickShowRecipients = () => this.setState({ showRecipients: !this.state.showRecipients });
  render() {
    const {
      addFileToContractFromMessageAction: addFileToContractFromMessage,
      classes,
      companyType,
      filesInContract,
      isInMessaging,
      msgObject: {
        // isSender,
        action,
        attachments,
        bodyText,
        contracts = [],
        createdAt,
        creator,
        creatorEmail,
        creatorMeta,
        isLoading,
        messageId,
        profileImageUrl,
        statusChanged,
        subject,
        to: recipients = [],
        type,
        bodyJson = {},
        contractId: contractIdInOfMessage,
        isSender,
        events: rawEvents = {},
      },
      isAnAdmin,
      isContractRequest,
      contractIdOfThread,
    } = this.props;
    const {
      emailBody = {},
      personalizeGreeting,
      greeting,
      signedBy,
      signatureText,
      rateDocsMap,
      rateDocIds,
    } = bodyJson;
    const allowFilesToBeAddedToContract = companyType === 'Contractor' && isContractRequest;
    const actionCheck = (() => {
      if (action === 'Created') return <span>Initiated Contract</span>;
      if (action === 'Contract Created') return <span>{companyType === 'Contractor' ? 'Rates Received' : 'Rates Sent'}</span>;
      if (action === 'Contract Updated') return <span>Contract Updated</span>;
      if (action === 'Request Created') return <span>Request Sent</span>;
      if (action === 'Responded') return <span>Responded To Contract Request</span>;
      if (action === 'Downloaded') return <span>Downloaded Contract</span>;
      if (action === 'Viewed') return <span>Viewed Contract</span>;
      if (action === 'Resent Contract' || action === 'Resent Request') return <span>{action}</span>;
    })();
    const activityType = (() => {
      if (type === 'note') return 'note';
      if (actionCheck || statusChanged) return 'action';
      if (action === 'Contract Updated') return 'update';
      return 'message';
    })();

    const Icon = {
      action: () => FlagIcon,
      update: () => EditIcon,
      message: () => MessageIcon,
      note: () => NotesIcon,
    }[activityType]();
    const creatorName = (() => {
      if (creatorMeta && creatorMeta.realActorEmail) return creatorMeta.realActorEmail;
      return creatorMeta && creatorMeta.name ? creatorMeta.name : creatorEmail;
    })();
    const firstNameLabel = (() => {
      const { firstName } = recipients.find(r => Boolean(r.firstName)) || {};
      if (firstName && recipients.length > 1) {
        return ` ${firstName}, ...[+${recipients.length - 1} ${pluralize(
          'other',
          recipients.length - 1
        )}]`;
      }
      if (firstName) return ` ${firstName},`;
      return ',';
    })();
    return (
      <div>
        <div className={classes.messageAvatarContainer}>
          <Avatar
            className={classes.messageAvatar}
            icon={<Icon className={classes.messageAvatarIcon} />}
          />
        </div>
        <Paper
          style={{
            ...styles.paperBox,
            ...(type === 'note' ? styles.paperBoxNotes : {}),
            ...(recipients && recipients.length && recipients[0].email === 'dl@tourconnect.com'
              ? styles.paperBoxMsgToDL : {}),
          }}
        >
          {
            isLoading ? (
              <div style={{ lineHeight: '32px' }}>
                sending...
                <LinearProgress/>
              </div>
            ) : (
              <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px' }}>
                <div className="flex-tc-sb">
                  <div className="flex-center">
                    <MsgAvatar
                      {...{
                        name: creatorName,
                        type: creator ? 'user' : 'email',
                        tooltipPosition: 'bottom-right',
                        avatarUrl: profileImageUrl,
                      }}
                    />
                    <div style={{ marginLeft: '16px' }}>
                      <b>{creatorName}</b>
                      <EmailTracking
                        showRecipients={this.state.showRecipients}
                        clickShowRecipients={this.clickShowRecipients}
                        isSender={isSender}
                        sentDate={createdAt}
                        format="D MMM YYYY, H:mm"
                        rawEvents={rawEvents}
                        recipients={recipients}
                      />
                    </div>
                  </div>
                  {
                    Boolean(isAnAdmin) && (
                      <a onClick={this.removeSingleFeedByTCAdmin} href="">
                        Remove
                      </a>
                    )
                  }
                </div>
              </div>
            )
          }
          <div style={{ paddingTop: '16px', color: isLoading ? 'rgba(0, 0, 0, 0.34)' : 'rgba(0, 0, 0, 0.54)' }}>
            <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', display: subject ? 'block' : 'none' }}>{subject}</div>
            {Boolean(personalizeGreeting) && (
              <div style={{ marginBottom: '10px', color: 'rgba(0, 0, 0, 0.87)', fontSize: '13px' }}>
                {greeting}{firstNameLabel}
              </div>
            )}
            <div
              className={`message-div ${classes.messageBody}`}
              dangerouslySetInnerHTML={{
                __html: (() => {
                  if (subject && subject.toLowerCase().indexOf('re:') === 0 && bodyText) {
                    return bodyText;
                  }
                  if (emailBody.html) return planer.extractFromHtml(emailBody.html, window.document);
                  return bodyText;
                })(),
              }}
            />
            {
              Boolean(contracts.length) && contracts.map(contract => (
                <CommentContract
                  key={contract.contractHFId}
                  contract={contract}
                />
              ))
            }
            {
              Boolean(rateDocIds && rateDocIds.length) && (
                <div className={classes.rateSheetsBox}>
                  <div className={classes.rateSheetsHeader}>
                    <div style={{ fontSize: '16px' }}>Rate Sheets</div>
                    <FlatButton
                      label="View Rates"
                      style={{ border: '1px solid #e0e0e0' }}
                      onClick={() => this.props.routerPush(`/contracting/contract/${contractIdInOfMessage}/policies`)}
                    />
                  </div>
                  {
                    R.values(rateDocsMap || {}).map(obj => (
                      <div key={obj.threadId} style={{ padding: '8px' }}>
                        {obj.locationName}
                      </div>
                    ))
                  }
                </div>
              )
            }
            {
              Boolean(attachments && attachments.length) ? (
                <Attachments
                  isInMessaging={isInMessaging}
                  contractIdOfThread={contractIdOfThread}
                  allowFilesToBeAddedToContract={allowFilesToBeAddedToContract}
                  filesInContract={filesInContract}
                  uploads={attachments}
                  addToContractFn={(filesToBeAdded) => {
                    addFileToContractFromMessage(messageId, R.map(R.merge({ source: 'emailScrape' }), filesToBeAdded));
                  }}
                />
              ) : <div/>
            }
          </div>
        </Paper>
      </div>
    );
  }
}

Comment.propTypes = propTypes;

Comment.defaultProps = {
  showContactLink: false,
};

const mapStateToProps = ({ user, contracting }, { isInMessaging }) => ({
  isAnAdmin: user.get('isAnAdmin'),
  historyFeedId: contracting.contractActivitiesProducts.getIn(['activities', 'historyFeedId']),
  isContractRequest: !isInMessaging && !contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']),
});

export default connect(mapStateToProps, {
  addFileToContractFromMessageAction,
  removeSingleFeedByTCAdmin: removeSingleFeedByTCAdminAction,
  routerPush,
})(injectSheet(styles)(Comment));



// WEBPACK FOOTER //
// ./src/app/components/contracting/comments/comment.jsx